import React, { Component } from 'react'
import CollectionList from '../collection-list'
import PageTitles from '../page-titles'
import Bio from '../artist-bio'

// Artist case studies for artist pages 
// Case studies component wraps the common
// collection rows component to display 
class ArtistCaseStudies extends Component {

  componentDidMount() {
    this.requestRows()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.active === this.props.active) return
    this.requestRows()
  }

  // Request rows only if rows are empty
  // And active is set to true
  // Active is if route matches 
  requestRows() {
    const { requestId, id, rows, active, onRequestRows } = this.props

    if (!id) return
    if (rows && (requestId === id)) return
    if (!active) return
    
    onRequestRows && onRequestRows(id)
  }

  handleBioClick = () => {
    if (this.bioEl) {
      const bioTop = this.bioEl.getBoundingClientRect().top
      const { setSmoothScroll, pageArtistSt } = this.props 
      setSmoothScroll && setSmoothScroll(bioTop + pageArtistSt)
    }
  }

  render() {
    const { subtitle, ...otherProps } = this.props 
    return (
      <div className="artist-case-studies">
        <div className="artist-case-studies__content">
          {<CollectionList {...this.props} />}
          <div ref={(el) => this.bioEl = el} className="artist-case-studies__bio">
            <Bio />   
          </div>
        </div>
        <div className="collection__overlay">
          <PageTitles 
            page={true} 
            visible={true} 
            subtitle={'biography'}
            handleClick={this.handleBioClick}
            {...otherProps} />
        </div>
      </div>
    )
  }
}

export default ArtistCaseStudies



// WEBPACK FOOTER //
// ./src/components/artist-case-studies-container/artist-case-studies.js